import { z } from 'zod';

export const ExportableWeekday = z.enum(['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']);
export type ExportableWeekday = z.infer<typeof ExportableWeekday>;

export const ExportableDayOfMonth = z.int().gte(0).lte(31);
export type ExportableDayOfMonth = z.infer<typeof ExportableDayOfMonth>;

export const ExportableTimezone = z.enum([
  'America/Los_Angeles',
  'America/Denver',
  'America/Chicago',
  'America/New_York',
]);
export type ExportableTimezone = z.infer<typeof ExportableTimezone>;

export const ExportableHourIncrement = z.number().gte(0).lte(23.99); // 24-hour base. allow increments (ie 2:30 = 14.5)
export type ExportableHourIncrement = z.infer<typeof ExportableHourIncrement>;

export const ExportableHourWhole = z.int().gte(0).lte(23); // 24-hour base. on the hour only
export type ExportableHourWhole = z.infer<typeof ExportableHourWhole>;

export const ExportableDayAndTimeRange = z.object({
  startTime: ExportableHourIncrement,
  startDay: ExportableWeekday,
  endTime: ExportableHourIncrement,
  endDay: ExportableWeekday,
  timezone: ExportableTimezone,
});
export type ExportableDayAndTimeRange = z.infer<typeof ExportableDayAndTimeRange>;
